export const DEFAULT_IMAGE_16_9 = './assets/img/default-image-16x9.png';
export const DEFAULT_IMAGE_4_3 = './assets/img/default-image-4x3.png';
export const DEFAULT_AVATAR = './assets/img/default-avatar.png';
export const DEFAULT_IMAGE = {
     DEFAULT_IMAGE_16_9,
     DEFAULT_IMAGE_4_3,
     DEFAULT_AVATAR,
};
export const CTX_ERR_INVALID_SESSION = 'INVALID_SESSION';
export const CTX_ERR_MISSING_AUTHORIZATION_HEADER =
     'MISSING_AUTHORIZATION_HEADER';
